'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import type { PanelTone } from '@/components/ui/panel';
import { Panel } from '@/components/ui/panel';
import { SettledSeal } from './settled-seal';
interface SettledBannerShellProps {
  /** Headline for the post-resolution graduation state. */
  title: string;
  /** Sub-line beneath the title. */
  body: ReactNode;
  /** Right-hand graduating-status slot, rendered inline and vertically centred. */
  trailing: ReactNode;
  /** Surface emphasis for the graduating state. */
  tone?: PanelTone;
}

/**
 * Banner shell for the post-resolution graduation state. A glossy green
 * seal-checkmark image + title + body sit on the left and the status slot sits
 * on the right. The row stays inline at every breakpoint to keep a short
 * vertical footprint.
 */
export function SettledBannerShell(t0) {
  const $ = _c(14);
  const {
    title,
    body,
    trailing,
    tone: t1
  } = t0;
  const tone = t1 === undefined ? "default" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SettledSeal className="size-11 shrink-0 sm:size-14" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== title) {
    t3 = <p className="font-medium text-body-lg text-foreground-primary sm:text-heading">{title}</p>;
    $[1] = title;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== body) {
    t4 = <p className="text-caption text-foreground-tertiary sm:text-body">{body}</p>;
    $[3] = body;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <div className="min-w-0 flex-1">{t3}{t4}</div>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5 || $[9] !== trailing) {
    t6 = <div className="flex items-center gap-3 px-4 sm:gap-5">{t2}{t5}{trailing}</div>;
    $[8] = t5;
    $[9] = trailing;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6 || $[12] !== tone) {
    t7 = <Panel tone={tone}>{t6}</Panel>;
    $[11] = t6;
    $[12] = tone;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}